import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

interface IDescriptionItemProps {
  title: string;
  value: string;
}

export const DescriptionItem: React.FC<IDescriptionItemProps> = ({ title, value }) => {
  return (
    <div>
      <UIText2 color="gray60_100">{title}</UIText2>
      <UIText2>{value}</UIText2>
    </div>
  );
};
